exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".forced_product_checkbox .form-el-input .text-container {\n  border: 1px solid #ebebeb;\n  margin: 0 0 0 0;\n  padding: 15px;\n}\n.forced_product_checkbox .form-el-input .link {\n  position: absolute;\n  right: 25px;\n  top: 15px;\n}\n.forced_product_checkbox .form-el-input .link a {\n  margin-left: 5px;\n}\n", ""]);

// exports
